import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, CardTitle, Form, FormGroup, Label, Input, FormText} from 'reactstrap';
import privateActions from '../../../../API/privateCalls/privateActions';
import {formatFloatString} from "../../../../utils/helperMethods";

class ModalCordon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading1:true,
            loading2:true,
            loading3:true,
            cinturonPasandoNivelTrue:'',
            cinturonPasandoNivelFalse:'',
            cinturonTiempo:''
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
        this.getInfo()
    }
getInfo(){
    privateActions.CinturonPasandoNivel(localStorage.getItem("idUsuario"),this.props.cinturon.id,true).then(res=>{
this.setState({loading1:false,cinturonPasandoNivelTrue:res})
    })
    privateActions.CinturonPasandoNivel(localStorage.getItem("idUsuario"),this.props.cinturon.id,false).then(res=>{
        this.setState({loading2:false,cinturonPasandoNivelFalse:res})

    })
    privateActions.CinturonTiempo(localStorage.getItem("idUsuario"),this.props.cinturon.id).then(res=>{
        this.setState({loading3:false,cinturonTiempo:res})

    })
}
    render() {
   
        return (
            <span className="d-inline-block mb-2 mr-2">
                <Button color="primary" onClick={this.toggle}>Ver Detalle</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>{this.props.cinturon.descripcion}</ModalHeader>
                    <ModalBody>

                    </ModalBody>
                    <Row className="d-flex justify-content-center">
                        <Col md="10 ">
                            <Card className="main-card mb-3">
                                <CardBody>
                                    
                                    <Form>
                                        {this.state.loading1?null:this.state.loading2?null:this.state.loading3?null:(
                                            <div>

<FormGroup>
<Label for="exampleEmail">Veces completo sin pasar de nivel</Label>
<Input value={this.state.cinturonPasandoNivelFalse} type="email" name="email"disabled id="exampleEmail"
       placeholder="no se pudo cargar"/>
</FormGroup>
<FormGroup>
<Label for="example">Veces completo pasando de nivel</Label>
<Input value={this.state.cinturonPasandoNivelTrue} type=""disabled name="localidad" id="localidad"
          placeholder="no se pudo cargar"/>
</FormGroup>
<FormGroup>
<Label for="example">Tiempo Promedio</Label>
<Input value={formatFloatString(this.state.cinturonTiempo)} type=""disabled name="localidad" id="flia"
        placeholder="no se pudo cargar"/>
</FormGroup>   </div>
                                        ) }
                                    
                                       
                              
                                        
                                        
                                      
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        </Row>
                        <ModalFooter>
                       
                        <Button color="primary" onClick={this.toggle}>Volver</Button>{' '}
                    </ModalFooter>
                </Modal>
            </span>
        );
    }
}

export default ModalCordon;



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/Cordon/component/cordonModal.js